import styled from 'styled-components';

const OutlineButton = styled.div`
    cursor: pointer;
    font-size: 1rem;
    background: ${props => props.theme.outlineBtn.bg};
    height: 3.125rem;
    line-height: 3.125rem;
    width: 100%;
    display: inline-block;
    text-align: center;
    color: ${props => props.theme.outlineBtn.txt};
    border: 0.063rem solid ${props => props.theme.outlineBtn.border};

    @media only screen and (min-width: 500px){
        font-size: 1.125rem;
    }
`;

export default OutlineButton;